<script>
    import { fly } from "svelte/transition";
    import { IndexesPage } from '../index'
</script>

<div transition:fly={{ x: 200 }}>
    <IndexesPage/>
</div>
